const key = "add-time-field";

const applicable = (resp) => {
	return resp.config.method === "GET" && resp.config.url.match(/api\/forms\/[0-9]*$/);
};

const timeField = {
	Id: -103,
	Name: "Header time",
	Key: {
		Code: "MOCK.TIME.HEADER"
	},
	Type: {
		Code: "TIME",
		IsReferentialData: false,
		IsEntity: false
	},
	Description: "Mock header time field",
	Order: 82,
	IsSmall: true,
	Template: "Time"
};

const modify = (resp) => {
	const form = resp.data.Data;
	const firstSection = form.Sections[0];

	const newTimeField = {
		...timeField,
		Section: {
			...firstSection
		}
	};

	form.Fields.push(newTimeField);
	return resp;
};

export const addTimeField = [key, applicable, modify];
